module.exports = __webpack_public_path__ + "static/media/kv-family.7a52fabb.png";